import { CLOUD } from '@/components/AlertsV2/constants';
import { useGraphQLApi } from '@/components/Common/useGraphQLApi';
import { useStoreData } from '@/components/Common/useStoreData';
import { permissionTypes } from '@/router/constant';
import { CloudService } from '@/services/api/integration.service';
import { computed, ref, watch } from 'vue';

export function useGetServicesForTeamByDuration({ subType }) {
  const { getDurationTime } = useStoreData();
  const servicesForTeam = ref<any[]>([]);
  const { data, error, makegraphQLCall, isLoading } = useGraphQLApi({
    params: {},
    queryName: '',
  });

  watch(data, async(currentValue)=> {
      const { data: awsData } = await CloudService.getAwsAccountConnectionNames();
      if (!awsData || !awsData.connectionNames) {
        console.error("AWS account connection names not available");
        return;
      }
      
      // Filter the services based on AWS connection names
      servicesForTeam.value = currentValue.filter((service) => awsData.connectionNames[service.label])
        .map((service) => ({
          key: service.key,
          label: awsData.connectionNames[service.label],
        }));
  })

  const fetchServicesForTeamByDuration = () => {
    const params = {
      serviceReq: {
        capability: CLOUD,
        subType,
      },
      duration: getDurationTime.value,
      permissions: [permissionTypes.READ, permissionTypes.WRITE],
    };
    makegraphQLCall(
      'getServiceForTeamByDuration',
      params,
      (resp) => resp?.data?.data?.services,
    );
  };

  return {
    data: servicesForTeam,
    error,
    fetchServicesForTeamByDuration,
    isLoading,
  };
}